import { dayLabel, formatTime, localDayKey } from "@healthos/shared";
/** The kind a coaching moment carries on Today, the same tag the server stages it with. */
export const COACHING_ATTENTION_KIND = "coaching";
/** How often an open thread checks for a reply. */
export const COACHING_THREAD_POLL_MS = 15_000;
const BURST_MS = 5 * 60_000;
const PENDING = "pending-";
const sameBurst = (a, b) => b !== undefined &&
    a.fromMe === b.fromMe &&
    Date.parse(b.sentAt) - Date.parse(a.sentAt) < BURST_MS &&
    localDayKey(a.sentAt) === localDayKey(b.sentAt);
/** The thread as rows to draw, from `from` on, with day dividers and one stamp per burst. */
export function coachingThreadRows(messages, from = 0) {
    const lastMine = messages.findLast((m) => m.fromMe);
    return messages.slice(from).map((m, i) => {
        const at = from + i;
        const prev = messages[at - 1];
        const pending = m.id.startsWith(PENDING);
        const last = !sameBurst(m, messages[at + 1]);
        const seen = m === lastMine && m.readAt !== null;
        return {
            message: m,
            divider: !prev || localDayKey(prev.sentAt) !== localDayKey(m.sentAt) ? dayLabel(m.sentAt) : null,
            stamp: last ? `${pending ? "Sending" : formatTime(m.sentAt)}${seen ? " · Seen" : ""}` : null,
            pending,
        };
    });
}
/** Whether the other side wrote something not yet read. */
export const hasUnseenMessages = (messages) => messages.some((m) => !m.fromMe && m.readAt === null);
/**
 * Mutation options for sending a message: it shows at once as "Sending", the draft clears,
 * and the draft comes back if the send fails. Each client passes them to its own useMutation.
 */
export function coachingSendOptions(input) {
    const { queryClient, key } = input;
    return {
        mutationFn: input.send,
        onMutate: async (body) => {
            await queryClient.cancelQueries({ queryKey: key });
            const pending = {
                id: `${PENDING}${Date.now()}`,
                fromMe: true,
                body,
                sentAt: new Date().toISOString(),
                readAt: null,
            };
            queryClient.setQueryData(key, (old) => ({
                messages: [...(old?.messages ?? []), pending],
            }));
            input.setDraft("");
            return { body };
        },
        onError: (_err, _body, ctx) => {
            if (ctx)
                input.setDraft(ctx.body);
        },
        onSuccess: () => input.onSent?.(),
        onSettled: () => input.onSettled?.(),
    };
}
//# sourceMappingURL=coaching-thread.js.map